import { IAssessment } from "imagineplus-assessments/types";

// FILTERING

function getDistinctSubjects(assessments: IAssessment[]) {
  return assessments
    .map((assessment) => assessment.subject)
    .filter((subject, index, self) => self.indexOf(subject) === index);
}

// SORTING

const byEndDate = (a: IAssessment, b: IAssessment): number => {
  const aEndDate = new Date(a.endDate);
  const bEndDate = new Date(b.endDate);
  return aEndDate.getTime() - bEndDate.getTime();
};

const byStartDate = (a: IAssessment, b: IAssessment): number => {
  const aStartDate = new Date(a.startDate);
  const bStartDate = new Date(b.startDate);
  return aStartDate.getTime() - bStartDate.getTime();
};
const byTestNumber = (a: IAssessment, b: IAssessment): number => (a.testNumber ?? 0) - (b.testNumber ?? 0);

const byStartDateEndDateTestNumber = (a: IAssessment, b: IAssessment): number => {
  const startDateComparison = byStartDate(a, b);
  if (startDateComparison !== 0) {
    return startDateComparison;
  }
  const endDateComparison = byEndDate(a, b);
  if (endDateComparison !== 0) {
    return endDateComparison;
  }
  return byTestNumber(a, b);
};

// MAIN FUNCTION

export default function disableFutureAssessments(assessments: IAssessment[], assessmentType: string[]): IAssessment[] {
  let result = assessments;
  assessmentType.forEach((type) => {
    result = disableFutureAssessmentsOfType(result, type);
  });

  return result;
}

function disableFutureAssessmentsOfType(assessments: IAssessment[], assessmentType: string) {
  const targetAssessments = assessments.filter((assessment) => assessment.assessmentType === assessmentType);
  const otherAssessments = assessments.filter((assessment) => assessment.assessmentType !== assessmentType);

  // get a distinct list of the subjects from the target assessments
  const updatedTargetAssessments = getDistinctSubjects(targetAssessments).map((subject) => {
    const assessmentsForSubject = targetAssessments.filter((assessment) => assessment.subject === subject);
    if (assessmentsForSubject.length < 2) {
      return assessmentsForSubject;
    }

    const inProgressAssessment = assessmentsForSubject.find(
      (assessment) => assessment.progress && assessment.progress === 50
    );

    if (inProgressAssessment) {
      const notStartedAssessments = assessmentsForSubject
        .filter((assessment) => !assessment.progress)
        .map((assessment) => ({ ...assessment, disabled: true }));

      return [inProgressAssessment, ...notStartedAssessments];
    }

    // no in progress assessments
    return assessmentsForSubject
      .sort(byStartDateEndDateTestNumber)
      .map((assessment, index) => ({ ...assessment, disabled: index > 0 }));
  });

  return [...updatedTargetAssessments.flat(), ...otherAssessments];
}

